
        import * as module0 from './controllers/clipboard_controller.js';import * as module1 from './controllers/mailto_controller.js';import * as module2 from './controllers/search_controller.js';import * as module3 from './controllers/theme_controller.js';import * as module4 from './controllers/toc_controller.js'
        const modules = {
            "./controllers/clipboard_controller.js": module0,
            "./controllers/mailto_controller.js": module1,
            "./controllers/search_controller.js": module2,
            "./controllers/theme_controller.js": module3,
            "./controllers/toc_controller.js": module4,
        };
        export default modules;
      